import { ProductDto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllProductsResponseModel extends GlobalResponseObject {
    data?: ProductDto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /ProductDto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: ProductDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 